import { render, staticRenderFns } from "./CategoriesManagePopup.vue?vue&type=template&id=48b597fe&scoped=true"
import script from "./CategoriesManagePopup.vue?vue&type=script&lang=js"
export * from "./CategoriesManagePopup.vue?vue&type=script&lang=js"
import style0 from "./CategoriesManagePopup.vue?vue&type=style&index=0&id=48b597fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b597fe",
  null
  
)

export default component.exports